<template>
  <div>
    <el-tree
      node-key="id"
      ref="loadNodeTree"
      class="list-tree"
      :load="loadNode"
      :props="treeProps"
      lazy
      @node-click="handleNodeClick"
    ></el-tree>
  </div>
</template>
<script>
// import "@/assets/css/dialog.css";
export default {
  data() {
    return {
      treeList: [],
      treeProps: {
        children: "children",
        label: "name",
      },
    };
  },
  props: {
    stageIng: Object,
    subjectIng: Object,
    parentId: Number,
  },
  methods: {
    loadNode(node, resolve) {
      if (node.level === 0) {
        this.getRequest("/wenjiaoopne/kc/question/getChapter", {
          stage_id: this.stageIng.id,
          subject_id: this.subjectIng.id,
          pid: this.parentId,
        })
          .then((result) => {
            return resolve(result.data.list);
          })
          .catch(() => {});
      }
      if (node.level > 0) {
        let _level = node.level;
        this.getRequest("/wenjiaoopne/kc/question/getChapter", {
          stage_id: this.stageIng.id,
          subject_id: this.subjectIng.id,
          level: ++_level,
          pid: node.data.id,
        })
          .then((result) => {
            return resolve(result.data.list);
          })
          .catch(() => {});
      }
    },
    handleNodeClick(item) {
      this.$emit("nodeCallBack", item);
    },
  },
};
</script>
<style scoped></style>
